import $ from 'jquery'

$(document).ready(function () {
  // Add link arrow
  var footerlinkArrow = $('footer .footerTop__col div > a,footer .footerTop__col .link')
  addLinkArrow(footerlinkArrow)
  function addLinkArrow (el) {
    el.html(function () {
      var text = $(this).text().trim().split(' ')
      var last = text.pop()
      var lastWord = last.substring(0, (last.length - 1))
      var lastChar = last.split('')
      var char = lastChar.pop()
      return text.join(' ') + (last.length ? ' ' + lastWord + '<span>' + char + '</span>' : last)
    })
  }
  // Add link arrow
})
